import { Texts, Media, Button } from "../Object";
import { Space, List } from "../Layout";
import { Link } from "react-router-dom";

const Contact = () => {
  return(
    <>
      {/* <Space size={['80px', '64px']}></Space> */}
      <div className="p-box__wrap--contact">
        <Media src={`title/contact`} alt={'CONTACT'} class={`p-img__title p-img__title--contact`} />
        <Space size={['64px', '48px']}></Space>

        <div className="l-row" data-state="middle">
          <div className="p-box__wrap--contact__title ">
            <Texts slug="title/contact" class="c-text--big c-text--en c-text--white"></Texts>
            <Texts slug="contact/body" class="c-text--bold c-text--white"></Texts>
          </div>

          <Space size={['48px 0 40px', '40px 0 32px']}>
            <div className="c-grid__repeat--2 c-grid__gap--1">
              <List Item={Item} length={2}></List>
            </div>
          </Space>

          <div className="p-box__wrap--contact__bottom">
            <Texts slug='contact/bottom-left' class="c-text--white c-text--bold"></Texts>
            <Space size={['0 16px 0 24px', '12px 0 18px']}>
              <Texts slug='contact/bottom-center' class="c-text--en c-text--white c-text--big"></Texts>
            </Space>
            <Texts slug='contact/bottom-right' class="c-text--white"></Texts>
          </div>
        </div>

        <Space size={['40px', '32px']}></Space>
      </div>

      <Line />
    </>
  )
}
export default Contact;

const Item = (props) => {
  const link = ['/contact/', '/document/'];
  const buttonName = ['contact', 'document'];
  return(
    <>
      <div className="p-box__wrap--contact__white-box">
        <Texts slug={`contact/top-${buttonName[props.index]}`} class="c-text--center"></Texts>
        <Space size={['26px auto 28px', '18px auto 20px']}>
          <Button link={link[props.index]} slug={buttonName[props.index]} type={props.index == 0 ? 'black-big' : 'big'}></Button>
        </Space>
        <Texts slug={`contact/bottom-${buttonName[props.index]}`} class="c-text--center"></Texts>
      </div>
    </>
  )
}

const Line = () => {
  return(
    <>
      <div className="p-box__line">
        <Space size={['60px', '56px']}></Space>
          <div className="l-row" data-state="middle">

            <div className="p-box__line--inner">
              
              <div className="p-box__line--left">
                <Texts slug="line/title" class="c-text--white"></Texts>
                <Space size={['24px 0 0', '18px 0 0']}>
                  <Texts slug="line/body" class="c-text--white"></Texts>
                </Space>
              </div>

              <Space size={['0 32px 0 40px', '24px auto 24px']}>
                <Media src="common/icon-line" alt="line QR" class="p-img__line"></Media>
              </Space>

              <div className="p-box__line--right">
                <Button slug="line" link="https://lin.ee/LTaN2bT" type="big"></Button>
                <Space size={['24px', '18px']} />
                <div className="p-box__line--id">
                  <Texts slug="line/id-title" class="c-text--white c-text--en"></Texts>
                  <Texts slug="line/id" class="c-text--white c-text--en"></Texts>
                </div>
              </div>

            </div>

          </div>
        <Space size={['60px', '56px']}></Space>
      </div>
    </>
  )
}